import Vue from 'vue'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Cookies from 'js-cookie'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import 'element-ui/lib/theme-chalk/index.css'

// 引入富文本组件
import QuillEditor from 'vue-quill-editor'
// 引入富文本组件样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import App from './App'
import store from './store'
import routerPaycools from './router/paycools/index.js'
import routerMoneypay from './router/ezpay/index.js'

import i18n from './lang'
import bus from './utils/bus'

import '@/permission' // permission control

import * as filters from './filters' // global filters
import commonFn from './utils/vuePrototypeFn'
// import utils from './utils/index'
import permission from './directive/permission/index' // 角色判断指令
Vue.use(permission)
Vue.use(QuillEditor)

import MfaVerifyDialog from '@/components/MfaVerifyDialog.vue'
import * as Sentry from "@sentry/vue";
import {initSentry} from "@/utils/sentryConfig";
Vue.component('MfaVerifyDialog', MfaVerifyDialog)

// 全局组件
const components = {
  ScopeSelect: () => import('@/components/ScopeSelect.vue')
}
// 注册全局组件
Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component)
})
let router

if (['paycools', 'moneypay','id','mx'].includes(process.env.VUE_APP_PLATFORM)) {
  import ('@/styles/custom-theme/paycools-index.css')
  import ('@/styles/paycools/index.scss')
  import('@/icons/paycools-index.js')
  router = routerPaycools
}

if (process.env.VUE_APP_PLATFORM === 'ezpay') {
  import ('@/styles/custom-theme/ezpay-index.css')
  import ('@/styles/ezpay/index.scss')
  import('@/icons/ezpay-index.js')
  router = routerMoneypay
}

// set ElementUI lang to EN
Vue.use(ElementUI, {
  locale,
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Object.defineProperty(Vue.prototype, '$bus', { value: bus.bus })
Object.defineProperty(Vue.prototype, '$commonFn', { value: commonFn })

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  // 仅生产注入，避免影响本地开发体验
  import('./utils/antiDebug').then(({ default: antiDebug }) => {
    // 可按需保留引用：window.__stopAntiDebug = antiDebug;
  })

  initSentry(Vue)
}

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  bus,
  render: h => h(App)
})

// 设备检测与重定向（非开发环境生效，仅国际平台）
;(function deviceRedirect() {
  // 规范化 pathname，去掉多余的斜杠
  // 例如 https://example.com//#/home -> pathname // -> /
  const cleanPathname = window.location.pathname.replace(/\/+/g, '/')
  if (cleanPathname !== window.location.pathname) {
    window.location.href = window.location.origin + cleanPathname + window.location.search + window.location.hash
  }
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  if (process.env.NODE_ENV === 'development' || !isMobile) return
  if (process.env.VUE_APP_PLATFORM === 'paycools') {
    const targetMobile = process.env.VUE_APP_URL_MOBILE
    const targetPC = process.env.VUE_APP_URL_PC
    const targetURL = isMobile ? targetMobile : targetPC
    const currentURL = window.location.origin + window.location.pathname
    if (currentURL.replace(/\/$/, '') !== targetURL.replace(/\/$/, '')) {
      window.location.href = targetURL + window.location.pathname + window.location.search + window.location.hash
    }
  }
})()
